module.exports = __webpack_public_path__ + "img/homej.b8570c58.png";